import { create } from 'zustand';
import type { User } from '@/types';

interface AuthState {
  user: User | null;
  isLoggedIn: boolean;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
}

const bootstrap = typeof window !== 'undefined' ? window.__CP_BOOTSTRAP__ ?? null : null;

export const useAuthStore = create<AuthState>((set) => ({
  user: bootstrap?.user ?? null,
  isLoggedIn: bootstrap?.isLoggedIn ?? false,
  isLoading: false,
  setUser: (user) => set({ user, isLoggedIn: Boolean(user) }),
  setLoading: (isLoading) => set({ isLoading }),
  logout: () => set({ user: null, isLoggedIn: false }),
}));
